export default (tourCriteria) => {
    const params = {};
    const element = tourCriteria.get('operators');

    if (element && element.length) {
        params.operators = element.pluck('id').join('.');
    }

    return params;
};